"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ListingOffersList {
    constructor(listingOffers) {
        this.listingOffers = listingOffers;
    }
    isEmpty() {
        return this.listingOffers.length === 0;
    }
    getCount() {
        return this.listingOffers.length;
    }
    getSimpleOfferCount() {
        let count = 0;
        this.listingOffers.forEach((listingOffer) => {
            count += listingOffer.simpleOfferList.getCount();
        });
        return count;
    }
    hasListingOffers() {
        return this.listingOffers.length > 0;
    }
    getFirstListingOffer() {
        return this.listingOffers[0];
    }
    sortByCheapest() {
        this.listingOffers.sort((a, b) => {
            const aCheapestPriceOffer = a.simpleOfferList.sortByCheapest().getFirstOffer().priceOfferList.getCheapestPriceOffer();
            const bCheapestPriceOffer = b.simpleOfferList.sortByCheapest().getFirstOffer().priceOfferList.getCheapestPriceOffer();
            if (aCheapestPriceOffer === null || bCheapestPriceOffer === null) {
                return 0;
            }
            return aCheapestPriceOffer.amount.withoutVat - bCheapestPriceOffer.amount.withoutVat;
        });
        return this;
    }
    sortByBestSelling() {
        this.listingOffers.sort((a, b) => a.order - b.order);
        return this;
    }
    updateDatalayerPositionInfo() {
        this.listingOffers.forEach((offer, index) => {
            offer.simpleOfferList.simpleOffers.forEach((simpleOffer) => {
                simpleOffer.dataLayer.ga4.setIndex(index + 1);
                simpleOffer.dataLayer.ga4.setListType(offer.simpleOfferList.getCount());
            });
        });
    }
}
exports.default = ListingOffersList;
